export default "https://cdn-static.gokick.com/assets/e64f1932100d759e3f947f362e9ecc59e4444740/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";